export default "__VITE_ASSET__DmKQ$oi4__"